import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useBlocker, useLocation, useNavigate, useParams } from 'react-router-dom';
import InputField from '../../component/form/FormInput';
import Button from '../../component/ui/Button';
import OtherDetails from './OtherDetails';
import NavigationTab from './NavigationTab';
import VendorsAddress from './VendorsAddress';
import ContactPerson from './ContactPerson';
import BankDetails from './BankDetails';
import UploadDoc from './VenUploadDocument';
import { createVendor, updateVendor, vendor_list } from '../../store/action/vendor';
import PageLoader from '../../component/PageLoader';
import { formatErrors, hasPermission, newObjectCreater } from '../../utils/controller';
import { toast } from 'react-toastify';
import Remark from './Remark';
import { isAllValuesEmpty, validateGSTNumber, validatePANCard } from '../../utils/utility';
import { master_data } from '../../store/action/master';
import { change_status } from '../../store/action/vendor';
import NavigationTabMain from '../vendors/VendorDetailsCom/NavigationTabMain';
import RenderContent from '../vendors/VendorDetailsCom/renderContent';
import { deleteVendorService, getCities, getVendorDetails } from '../../services/vendor';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import Modal from '../../component/modal/Modal';

const CreateVendors = () => {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [error, setError] = useState({});
	const [disabled, setDisabled] = useState(id ? true : false);
	const [pageLoader, setPageLoader] = useState(false);
	const isVendorDisplayNameTouched = useRef(false);
	const [isEdit, setIsEdit] = useState(false);
	const [isVendorSaving, setIsVendorSaving] = useState({
		status: null,
		isLoader: false,
	});
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isVendorAutoSave, setIsVendorAutoSave] = useState(false);
	const [activeTab, setActiveTab] = useState('Other Details');
	const [activeTabMain, setActiveTabMain] = useState('Information');
	const [projectTitle, setProjectTitle] = useState('Create Vendor');
	const [isDeleteVendorModalOpen, setIsDeleteVendorModalOpen] = useState(false);
	const [vendorStatusModal, setVendorStatusModal] = useState({
		isOpen: false,
		status: false,
	});
	const [isUpdateVendorModalOpen, setIsUpdateVendorModalOpen] = useState(false);
	const [nextStatus, setNextStatus] = useState();
	const [vendorContact, setVendorContact] = useState([]);
	const [cityList, setCityList] = useState([]);
	const [vendorBasicData, setVendorBasicData] = useState({
		vendor_name: '',
		vendor_display_name: '',
		drug_license_number: '',
		email: '',
		phone_landline: '',
		phone_mobile: '',
		status: 1,
	});
	const [otherDetailsData, setOtherDetailsData] = useState({
		pan: '',
		gst: '',
		currency: 'INR',
		payment_terms: '0',
		website_url: '',
		designation: '',
	});
	const [address, setAddress] = useState({
		attention: '',
		country_id: null,
		state_id: null,
		street_1: '',
		street_2: '',
		city_id: null,
		zip_code: '',
	});
	const [bankDetails, setBankDetails] = useState([]);
	const [fssaiDoc, setFassaiDoc] = useState(null);
	const [gstDoc, setGstDoc] = useState(null);
	const [drugLicanceDocs, setDrugLicanceDocs] = useState(null);
	const [panDocs, setPanDocs] = useState(null);
	const [adharDocs, setAdharDocs] = useState(null);
	const [remark, setRemark] = useState({
		remark_text: '',
	});
	const [vendorDocumentId, setVendorDocumentId] = useState(null);
	const [vendorDetails, setVendorDetails] = useState();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	
	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}

	useEffect(() => {
		if (!id && vendorDetails?.vendor_id !== Number(id)) return;

		let otherDetails = vendorDetails?.vendor_other_details;
		let address = vendorDetails?.vendor_address;
		let vendorDocuments = vendorDetails?.vendor_documents;
		setVendorDocumentId(vendorDocuments?.vendor_document_id || null);
		setGstDoc(vendorDocuments?.gst_certificate || null);
		setDrugLicanceDocs(vendorDocuments?.drug_license || null);
		setAdharDocs(vendorDocuments?.aadhar_card || null);
		setPanDocs(vendorDocuments?.pan_card || null);
		setFassaiDoc(vendorDocuments?.fssai_license || null);
		let vendorRemarks = vendorDetails?.vendor_remarks;
		setVendorContact(vendorDetails?.contact_person);
		setBankDetails(vendorDetails?.vendor_bank_details);
		setVendorBasicData({
			vendor_name: vendorDetails?.vendor_name ? vendorDetails?.vendor_name : '',
			vendor_display_name: vendorDetails?.vendor_display_name
				? vendorDetails?.vendor_display_name
				: '',
			drug_license_number: vendorDetails?.drug_license_number
				? vendorDetails?.drug_license_number
				: '',
			email: vendorDetails?.email ? vendorDetails?.email : '',
			phone_landline: vendorDetails?.phone_landline ? vendorDetails?.phone_landline : '',
			phone_mobile: vendorDetails?.phone_mobile ? vendorDetails?.phone_mobile : '',
			status: vendorDetails?.status || null,
		});

		setAddress({
			address_id: address?.address_id ? address?.address_id : null,
			attention: address?.attention ? address?.attention : '',
			country_id: address?.country_id ? address?.country_id : null,
			state_id: address?.state_id ? address?.state_id : null,
			street_1: address?.street_1 ? address?.street_1 : '',
			street_2: address?.street_2 ? address?.street_2 : '',
			city_id: address?.city_id ? address?.city_id : '',
			zip_code: address?.zip_code ? address?.zip_code : '',
		});

		setOtherDetailsData({
			vendor_other_details_id: otherDetails?.vendor_other_details_id
				? otherDetails?.vendor_other_details_id
				: null,
			pan: otherDetails?.pan ? otherDetails?.pan : '',
			gst: otherDetails?.gst ? otherDetails?.gst : '',
			currency: 'INR',
			payment_terms: otherDetails?.payment_terms ? otherDetails?.payment_terms : '',
			website_url: otherDetails?.website_url ? otherDetails?.website_url : '',
			designation: otherDetails?.designation ? otherDetails?.designation : '',
		});
		setRemark({
			remark_text: vendorRemarks?.remark_text || '',
			vendor_remark_id: vendorRemarks?.vendor_remark_id || null,
		});
	}, [id, vendorDetails]);

	const handleFetchVendorDetails = async () => {
		if (id) {
			setPageLoader(true);
			const { vendors } = await getVendorDetails(id);
			setVendorDetails(vendors);
			setProjectTitle('Vendor Details');
			setPageLoader(false);
		}
	};

	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	useEffect(() => {
		dispatch(master_data());
	}, [dispatch]);

	const navigateRouter = (path) => {
		navigate(path);
	};

	const handleBasicInputChange = (key, value) => {
		const updatedData = { ...vendorBasicData, [key]: value };
		setVendorBasicData(updatedData);

		if (!isVendorDisplayNameTouched.current && key === 'vendor_name') {
			setVendorBasicData({ ...updatedData, vendor_display_name: value });
		}

		if (key === 'drug_license_number') {
			if (value === '' || value === null) {
				const newError = { ...error, [key]: 'Drug license is not valid' };
				setError(newError);
			} else {
				const newError = { ...error };
				delete newError?.[key];
				setError(newError);
			}
		} else {
			if (value && error[key]) {
				if (key === 'vendor_name') {
					delete error?.vendor_display_name;
				}
				delete error?.[key];
			}
		}
	};

	const handleSubmit = () => {
		const newError = { ...error };

		if (!vendorBasicData.vendor_name || vendorBasicData.vendor_name.trim() === '') {
			newError.vendor_name = 'Vendor name is required';
		} else {
			delete newError.vendor_name;
		}

		if (!vendorBasicData.vendor_display_name || vendorBasicData.vendor_display_name.trim() === '') {
			newError.vendor_display_name = 'Vendor display name is required';
		} else {
			delete newError.vendor_display_name;
		}

		if (!vendorBasicData.drug_license_number || vendorBasicData.drug_license_number.trim() === '') {
			newError.drug_license_number = 'Drug license number is required';
		} else {
			delete newError.drug_license_number;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return;
		}
	};

	const handleValidateIconClick = (key) => {
		if (error?.[key]) {
			const newError = { ...error };
			delete newError[key];
			setError(newError);
		}
	};

	const handleOtherDetailsInputChange = (key, value) => {
		const updatedData = { ...otherDetailsData, [key]: value };
		setOtherDetailsData(updatedData);

		if (key === 'pan') {
			if (value !== '' && value !== null) {
				if (!validatePANCard(value)) {
					const newError = { ...error, [key]: 'Pan number is not valid' };
					setError(newError);
				} else {
					const newError = { ...error };
					delete newError?.[key];
					setError(newError);
				}
			} else {
				const newError = { ...error };
				delete newError?.[key];
				setError(newError);
			}
		} else if (key === 'gst') {
			if (value !== '' && value !== null) {
				if (!validateGSTNumber(value)) {
					const newError = { ...error, [key]: 'Gst number is not valid' };
					setError(newError);
				} else {
					const newError = { ...error };
					delete newError?.[key];
					setError(newError);
				}
			} else {
				const newError = { ...error };
				delete newError?.[key];
				setError(newError);
			}
		} else {
			if (value && error[key]) {
				delete error?.[key];
			}
		}
	};

	const handleAddressInputChange = (key, value) => {
		const updatedData = { ...address, [key]: value };
		setAddress(updatedData);
		if (value && error[key]) {
			delete error?.[key];
		}
	};

	const submitForm = async (status) => {
		const newError = { ...error };

		if (!vendorBasicData.vendor_name || vendorBasicData.vendor_name.trim() === '') {
			newError.vendor_name = 'Vendor name is required';
		} else {
			delete newError.vendor_name;
		}

		if (!vendorBasicData.vendor_display_name || vendorBasicData.vendor_display_name.trim() === '') {
			newError.vendor_display_name = 'Vendor display name is required';
		} else {
			delete newError.vendor_display_name;
		}

		if (!vendorBasicData.drug_license_number || vendorBasicData.drug_license_number.trim() === '') {
			newError.drug_license_number = 'Drug license number is required';
		} else {
			delete newError.drug_license_number;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return;
		}

		setIsVendorSaving((prev) => ({
			...prev,
			status: status,
			isLoader: true,
		}));

		const formData = new FormData();
		const { currency, payment_terms, ...restOtherDetails } = otherDetailsData;
		if (!id) {
			const vendorObj = {
				...vendorBasicData,
				vendor_other_details: !isAllValuesEmpty({
					...restOtherDetails,
					payment_terms: payment_terms,
				})
					? JSON.stringify([{ ...otherDetailsData, payment_terms: payment_terms || '', tds: null }])
					: '',
				address: !isAllValuesEmpty(address) ? JSON.stringify([address]) : '',
				contact_person: vendorContact?.length > 0 ? JSON.stringify(vendorContact) : '',
				bank_details: bankDetails?.length > 0 ? JSON.stringify(bankDetails) : '',
				remarks: remark.remark_text || '',
				status: Number(status),
			};

			for (const key in vendorObj) {
				formData.append(key, vendorObj[key]);
			}

			if (gstDoc) {
				formData.append('gst_certificate_doc', gstDoc);
			}
			if (drugLicanceDocs) {
				formData.append('drug_license_doc', drugLicanceDocs);
			}
			if (panDocs) {
				formData.append('pan_card_doc', panDocs);
			}
			if (adharDocs) {
				formData.append('aadhar_card_doc', adharDocs);
			}
			if (fssaiDoc) {
				formData.append('fssai_license_doc', fssaiDoc);
			}

			try {
				const res = await dispatch(createVendor(formData));
				if (res?.success) {
					toast.success(res?.message);
					setIsLocationBlocker(false);
					setIsVendorAutoSave(false);
					setTimeout(() => {
						navigate(`/user/${suburl}/vendor`);
					}, 300);
				} else {
					if (res?.code === 422) {
						let errorObj = formatErrors(res?.message);
						setError(errorObj);
					} else {
						toast.error(res?.message || 'Something went wrong');
					}
				}
			} catch (error) {
				setError(error);
			} finally {
				setPageLoader(false);
				setIsVendorSaving((prev) => ({
					...prev,
					status: status,
					isLoader: false,
				}));
			}
		}
		if (id) {
			const { currency, payment_terms, ...restOtherDetails } = otherDetailsData;

			const updateVendorObj = {
				...vendorBasicData,
				vendor_other_details: !isAllValuesEmpty({
					...restOtherDetails,
					payment_terms: payment_terms,
				})
					? JSON.stringify([{ ...otherDetailsData, payment_terms: payment_terms || '', tds: null }])
					: '',
				address: !isAllValuesEmpty(address) ? JSON.stringify([address]) : '',
				remarks: JSON.stringify([remark]) || '',
				status: Number(status),
			};

			for (const key in updateVendorObj) {
				formData.append(key, updateVendorObj[key]);
			}

			try {
				const res = await dispatch(updateVendor(id, formData));
				if (res?.success) {
					toast.success(res?.message);
					setIsEdit(false);
					setDisabled(true);
				} else {
					if (res.code === 422) {
						let errorObj = formatErrors(res?.message);
						setError(errorObj);
					} else {
						toast.error(res?.message || 'Something went wrong');
					}
				}
			} catch (error) {
				setError(error);
			} finally {
				setPageLoader(false);
				setIsVendorSaving(false);
			}
		}
	};

	const markAsInactive = () => {
		let vendorIds = Number(id);
		let formBody = {
			vendor_ids: [vendorIds],
			status: 2,
		};
		dispatch(change_status(formBody)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				// let param = `filterBy=vendor_id&filterValue=${id}`;
				// vendor_list(param);
				handleFetchVendorDetails();
			} else {
				toast.error(res?.message);
			}
		});
	};

	const markAsActive = () => {
		let vendorIds = Number(id);
		let formBody = {
			vendor_ids: [vendorIds],
			status: 1,
		};
		dispatch(change_status(formBody)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				handleFetchVendorDetails();
				// let param = `filterBy=vendor_id&filterValue=${id}`;
				// dispatch(vendor_list(param));
			} else {
				toast.error(res?.message);
			}
		});
	};

	async function handleDeleteVendor() {
		try {
			await deleteVendorService([id]);
			navigateRouter(`/user/${suburl}/vendor`);
			toast.success('Vendor Deleted Successfully.');
		} catch (error) {
			toast.success(error?.message || 'Something went wrong!');
		}
	}

	function handleCreateButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `purchases-order-create`,
			1: baseUrl + `purchases-receive-create`,
			2: baseUrl + `purchases-bills-create`,
			3: baseUrl + `payment-made-create`,
			4: baseUrl + `credit-note-create`,
		};

		navigate(urlMap[Number(index)], { state: { key: id, value: vendorBasicData?.vendor_name } });
	}

	useBlocker((tx) => {
		if (isLocationBlocker && !id) {
			setIsNextLocation(tx);
			setIsVendorAutoSave(true);
			return true;
		}
		return false;
	});

	useEffect(() => {
		if (address?.state_id !== null && address?.state_id !== '') {
			getCity(address?.state_id);
		}
	}, [address.state_id]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useEffect(() => {
		handleFetchVendorDetails();
	}, [id]);

	return (
		<>
			{pageLoader ? (
				<PageLoader />
			) : (
				<div className="">
					<div
						className=""
						style={{ position: 'sticky', top: 0, zIndex: 100 }}
					>
						<div className="product-pg-header add-product ">
							{id ? <p>Vendor Details</p> : <p>Add New Vendor</p>}
							<div className="add-product-button">
								{id && disabled && (
									<>
										<Button
											type="button"
											className="btn-primary mt-0 px-4"
											disabled={
												!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)
											}
											button="Edit"
											onClick={() => {
												setDisabled(false);
												setIsEdit(true);
												setProjectTitle('Update Vendor');
												setActiveTabMain('Information');
											}}
										/>

										<div className="dropdown">
											<button
												className="btn btn-light mt-0 px-4 dropdown-toggle"
												style={{
													width: '163px',
													height: '32px',
													fontSize: '14px',
													fontWeight: '500',
												}}
												type="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												New Transaction
											</button>
											<ul className="dropdown-menu font-14">
												{hasPermission(
													'purchases.purchase_orders.create',
													user?.role?.role_permissions,
												) && (
													<li>
														<button
															className="dropdown-item"
															onClick={() => handleCreateButton(0)}
														>
															Create Purchase Order
														</button>
													</li>
												)}
												{hasPermission(
													'purchases.purchase_receivescreate',
													user?.role?.role_permissions,
												) && (
													<li>
														<button
															className="dropdown-item"
															onClick={() => handleCreateButton(1)}
														>
															Create Purchase Receive
														</button>
													</li>
												)}
												{hasPermission(
													'purchases.purchase_bills.create',
													user?.role?.role_permissions,
												) && (
													<li>
														<button
															className="dropdown-item"
															onClick={() => handleCreateButton(2)}
														>
															Create Purchase Bill
														</button>
													</li>
												)}
												{hasPermission(
													'purchases.payments_made.create',
													user?.role?.role_permissions,
												) && (
													<li>
														<button
															className="dropdown-item"
															onClick={() => handleCreateButton(3)}
														>
															Create Payment Made
														</button>
													</li>
												)}

												{hasPermission(
													'purchases.credit_note.create',
													user?.role?.role_permissions,
												) && (
													<li>
														<a
															className="dropdown-item"
															onClick={() => handleCreateButton(4)}
														>
															Create Credits Notes
														</a>
													</li>
												)}
											</ul>
										</div>
										{vendorDetails?.status === 0 || vendorDetails?.status === 2 ? (
											//clone === false &&
											<Button
												type="button"
												className="btn-gray mt-0 px-4"
												button="Mark as Active"
												disabled={
													!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)
												}
												onClick={() => {
													setVendorStatusModal({
														isOpen: true,
														status: true,
													});
												}}
											/>
										) : (
											//clone === false &&
											<Button
												type="button"
												className="btn-gray mt-0 px-4"
												button="Mark as Inactive"
												disabled={
													!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)
												}
												onClick={() => {
													setVendorStatusModal({
														isOpen: true,
														status: false,
													});
												}}
											/>
										)}

										{/* Clone Button */}
										{/* <Button
											type="button"
											className="btn-gray mt-0 px-4"
											button="Clone"
											onClick={() => {
												cloneVendor();
												setActiveTabMain('Information'); 
											}}
										/> */}

										{vendorDetails &&
											vendorDetails.purchase_order.length === 0 &&
											vendorDetails.purchase_receive.length === 0 && (
												<Button
													type="button"
													button="Delete"
													disabled={
														!hasPermission('purchases.vendors.delete', user?.role?.role_permissions)
													}
													className="mt-0 px-4 btn-gray relative"
													onClick={() => {
														setIsDeleteVendorModalOpen(true);
													}}
												/>
											)}
									</>
								)}

								{disabled === false && (
									<>
										<Button
											type="button"
											className="btn-primary mt-0 px-4"
											button="Save"
											loader={isVendorSaving.isLoader && isVendorSaving.status === 1}
											disabled={
												(isVendorSaving.isLoader && isVendorSaving.status === 1) ||
												(id
													? !hasPermission('purchases.vendors.edit', user?.role?.role_permissions)
													: !hasPermission(
															'purchases.vendors.create',
															user?.role?.role_permissions,
														))
											}
											onClick={() => {
												setIsVendorAutoSave(false);
												if (isEdit) {
													setNextStatus(1);
													setIsUpdateVendorModalOpen(true);
												} else {
													submitForm(
														vendorBasicData.status === 0 ? 1 : Number(vendorBasicData.status),
													);
												}
											}}
										/>
									</>
								)}
								{disabled === false && (
									<>
										<Button
											type="button"
											className="btn-primary mt-0 px-4"
											button="Save As Draft"
											loader={isVendorSaving.isLoader && isVendorSaving.status === 0}
											disabled={
												(isVendorSaving.isLoader && isVendorSaving.status === 0) ||
												(id
													? !hasPermission('purchases.vendors.edit', user?.role?.role_permissions)
													: !hasPermission(
															'purchases.vendors.create',
															user?.role?.role_permissions,
														))
											}
											onClick={() => {
												setIsVendorAutoSave(false);
												if (isEdit) {
													setNextStatus(0);
													setIsUpdateVendorModalOpen(true);
												} else {
													submitForm(0);
												}
											}}
										/>
									</>
								)}
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => {
										if (isEdit) {
											setDisabled(true);
											setIsEdit(false);
											setProjectTitle('Vendor Details');
											setActiveTabMain('Information');
										} else {
											navigateRouter(`/user/${suburl}/vendor`);
										}
									}}
								/>
							</div>
						</div>
						<div
							style={{ backgroundColor: '#EDEDF7', marginTop: '-10px', paddingLeft: '20px' }}
							className={id ? '' : 'd-none'}
						>
							<NavigationTabMain
								activeTabMain={activeTabMain}
								user={user}
								setActiveTabMain={setActiveTabMain}
							/>
						</div>
						<div className="tab-content">
							<RenderContent
								activeTabMain={activeTabMain}
								vendorData={{ key: Number(id), value: vendorBasicData?.vendor_display_name }}
							/>
							{/* Pass activeTabMain here */}
						</div>
					</div>
					{/* Vendor Form */}
					<div className={activeTabMain === 'Information' ? '' : 'd-none'}>
						<div
							className="max-w-1297"
							style={{ padding: '1rem 2rem 0' }}
						>
							<div className={id ? '' : 'd-none'}>
								<div
									style={{
										borderBottom: '1px solid #EEEFF3',
										height: '75px',
										width: '100%',
										gap: '10px',
									}}
									className="d-flex"
								>
									<div
										style={{ width: '25%', height: '68px', marginTop: '-12px' }}
										className="d-flex flex-column"
									>
										<div>
											<h4
												className="fw-bold"
												style={{ fontSize: '16px' }}
											>
												Summary
											</h4>
										</div>
										<div>
											<p style={{ fontSize: '1.5rem', color: '#555B67' }}>
												Total Outstanding Payables
											</p>
										</div>
										<div>
											<h4
												className="fw-bold"
												style={{ fontSize: '16px' }}
											>
												{`₹ ${vendorDetails?.payables || 0}`}
											</h4>
										</div>
									</div>

									<div
										style={{
											height: '55px',
											width: '65%',
											marginTop: '10px',
											borderLeft: '1px solid #EEEFF3',
											paddingLeft: '55px',
										}}
										className="d-flex flex-column "
									>
										<div>
											<p style={{ fontSize: '1.5rem', color: '#555B67' }}>Due In Next 15Days</p>
										</div>
										<div>
											<h4
												className="fw-bold"
												style={{ fontSize: '16px' }}
											>
												{`₹ ${vendorDetails?.dueInNext15Days || 0}`}
											</h4>
										</div>
									</div>
								</div>
								{/* Summary End */}

								<div
									className="d-flex"
									style={{ gap: '10px', padding: '10px 0px 10px 0px ', fontSize: '1.5rem' }}
								>
									<b style={{ borderBottom: '2px solid #3B58FF', height: '24px' }}>Information</b>
									<p>Referrals</p>
								</div>
							</div>

							<div className="row">
								<div className="col">
									<InputField
										label="Vendor Name"
										placeholder="Enter Vendor Name"
										type="text"
										required={true}
										value={vendorBasicData.vendor_name}
										onChange={(valueData) => {
											const value = valueData.replace(/[^A-Za-z\s']/g, '');
											handleBasicInputChange('vendor_name', value);
										}}
										disabled={disabled}
										error={error?.vendor_name}
										autoFocus={true}
									/>
								</div>
								<div className="col">
									<InputField
										label="Vendor Display Name"
										placeholder="Vendor Display Name"
										type="text"
										onChange={(valueData) => {
											const value = valueData.replace(/[^A-Za-z\s']/g, '');
											handleBasicInputChange('vendor_display_name', value);
										}}
										value={vendorBasicData.vendor_display_name}
										disabled={disabled}
										required={true}
										error={error?.vendor_display_name}
										onFocus={(e) => {
											isVendorDisplayNameTouched.current = true;
										}}
									/>
								</div>
								<div className="col">
									<InputField
										label="Drug License Number"
										placeholder="Drug License Number"
										type="text"
										required={true}
										value={vendorBasicData.drug_license_number}
										onChange={(value) => handleBasicInputChange('drug_license_number', value)}
										disabled={disabled}
										error={error?.drug_license_number}
										onValidateIconClick={() => handleValidateIconClick('drug_license_number')}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<InputField
										label="Email"
										placeholder="Email Address"
										type="text"
										value={vendorBasicData.email}
										onBlur={(e) => {
											let vendorError = { ...error };
											let value = e.target.value;
											if (value) {
												if (validateEmail(value)) {
													delete vendorError.email;
													setError(vendorError);
													handleBasicInputChange('email', value);
												} else {
													vendorError.email = 'Please enter valid email address';
													setError(vendorError);
													handleBasicInputChange('email', value);
												}
											} else {
												delete vendorError.email;
												setError(vendorError);
												handleBasicInputChange('email', value);
											}
										}}
										onChange={(value) => handleBasicInputChange('email', value)}
										disabled={disabled}
										error={error?.email}
									/>
								</div>

								<div className="col">
									<InputField
										label="Phone (Landline)"
										placeholder="Landline No."
										type="text"
										onBlur={(e) => {
											let vendorError = { ...error };
											let valueData = e.target.value;
											let value = valueData?.replace(/[^0-9]/g, '');
											if (value) {
												if (value.length > 10 || value.length < 9) {
													vendorError.phone_landline = 'Please enter valid phone landline number';
													handleBasicInputChange('phone_landline', value);
													setError(vendorError);
												} else {
													delete vendorError.phone_landline;
													setError(vendorError);
													handleBasicInputChange('phone_landline', value);
												}
											} else {
												delete vendorError.phone_landline;
												setError(vendorError);
												handleBasicInputChange('phone_landline', value);
											}
										}}
										value={vendorBasicData.phone_landline}
										onChange={(valueData) => {
											let vendorError = { ...error };
											let value = valueData?.replace(/[^0-9]/g, '');
											if (value) {
												if (value.length < 12) {
													if (value.length > 11 || value.length < 9) {
														vendorError.phone_landline = 'Please enter valid phone landline number';
														handleBasicInputChange('phone_landline', value);
														setError(vendorError);
													} else {
														delete vendorError.phone_landline;
														setError(vendorError);
														handleBasicInputChange('phone_landline', value);
													}
												}
											} else {
												delete vendorError.phone_landline;
												setError(vendorError);
												handleBasicInputChange('phone_landline', value);
											}
										}}
										disabled={disabled}
										error={error?.phone_landline}
									/>
								</div>

								<div
									className="col"
									style={{ paddingBottom: '15px' }}
								>
									<InputField
										label="Phone (Mobile)"
										placeholder="Vendor Mobile (Work)"
										type="text"
										onBlur={(e) => {
											let vendorError = { ...error };
											let valueData = e.target.value;
											let value = valueData?.replace(/[^0-9]/g, '');
											if (value) {
												const regex = /^[1-9]\d{9}$/;
												if (regex.test(value)) {
													if (value.length > 10 || value.length < 10) {
														vendorError.phone_mobile = 'Please enter valid phone mobile number';
														handleBasicInputChange('phone_mobile', value);
														setError(vendorError);
													} else {
														delete vendorError.phone_mobile;
														setError(vendorError);
														handleBasicInputChange('phone_mobile', value);
													}
												} else {
													vendorError.phone_mobile = `Please enter valid mobile number ${value[0] === 0 ? 'and cannot start with 0' : ''}`;
													handleBasicInputChange('phone_mobile', value);
													setError(vendorError);
												}
											} else {
												delete vendorError.phone_mobile;
												setError(vendorError);
												handleBasicInputChange('phone_mobile', value);
											}
										}}
										value={vendorBasicData.phone_mobile}
										onChange={(valueData) => {
											let vendorError = { ...error };
											let value = valueData?.replace(/[^0-9]/g, '');
											if (value) {
												if (value.length < 11) {
													const regex = /^[1-9]\d{9}$/;
													if (regex.test(value)) {
														if (value.length > 10 || value.length < 10) {
															vendorError.phone_mobile = 'Please enter valid mobile number';
															handleBasicInputChange('phone_mobile', value);
															setError(vendorError);
														} else {
															delete vendorError.phone_mobile;
															setError(vendorError);
															handleBasicInputChange('phone_mobile', value);
														}
													} else {
														vendorError.phone_mobile = `Please enter valid mobile number ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
														handleBasicInputChange('phone_mobile', value);
														setError(vendorError);
													}
												}
											} else {
												delete vendorError.phone_mobile;
												setError(vendorError);
												handleBasicInputChange('phone_mobile', value);
											}
										}}
										disabled={disabled}
										error={error?.phone_mobile}
									/>
								</div>
							</div>
							<NavigationTab
								activeTab={activeTab}
								setActiveTab={setActiveTab}
							/>
							{activeTab === 'Other Details' && (
								<OtherDetails
									data={otherDetailsData}
									handleInputChange={handleOtherDetailsInputChange}
									error={error}
									disabled={disabled}
									setError={setError}
								/>
							)}
							{activeTab === 'Address' && (
								<VendorsAddress
									data={address}
									cityList={cityList}
									getCity={getCity}
									error={error}
									handleInputChange={handleAddressInputChange}
									disabled={disabled}
								/>
							)}
							{activeTab === 'Contact person' && (
								<ContactPerson
									isEdit={isEdit}
									vendorContact={vendorContact}
									setVendorContact={setVendorContact}
									reloadTable={handleFetchVendorDetails}
									vendorId={id}
								/>
							)}
							{activeTab === 'Bank Details' && (
								<BankDetails
									isEdit={isEdit}
									error={error}
									data={bankDetails}
									setBankDetails={setBankDetails}
									reloadTable={handleFetchVendorDetails}
									vendorId={id}
								/>
							)}
							{activeTab === 'Upload Document' && (
								<UploadDoc
									setVendorDocumentId={setVendorDocumentId}
									vendorDocumentId={vendorDocumentId}
									setFassaiDoc={setFassaiDoc}
									setGstDoc={setGstDoc}
									setDrugLicanceDocs={setDrugLicanceDocs}
									setAdharCardDocs={setAdharDocs}
									setPanDocs={setPanDocs}
									fssaiDoc={fssaiDoc}
									gstDoc={gstDoc}
									drugLicanceDocs={drugLicanceDocs}
									adharDocs={adharDocs}
									panDocs={panDocs}
									reloadTable={handleFetchVendorDetails}
									vendorId={id}
								/>
							)}

							{activeTab === 'Remarks' && (
								<Remark
									disabled={disabled}
									setRemark={setRemark}
									remark={remark}
								/>
							)}
						</div>
					</div>

					{isUpdateVendorModalOpen && (
						<ConfirmationModal
							content={
								<p
									style={{
										textAlign: 'center',
										backgroundColor: '#E6F5FF',
										padding: '10px',
										borderRadius: '5px',
										fontWeight: '500',
										color: 'black',
									}}
								>
									Are you sure you want to update{' '}
									<span
										style={{
											fontWeight: '600',
										}}
									>
										{vendorBasicData.vendor_name}
									</span>{' '}
									data ?
								</p>
							}
							isOpen={isUpdateVendorModalOpen}
							title="Update Vendor"
							onCancel={() => {
								setIsUpdateVendorModalOpen(false);
							}}
							onOk={() => {
								if (
									!vendorBasicData.drug_license_number ||
									vendorBasicData.drug_license_number.trim() === ''
								) {
									handleSubmit(vendorBasicData.status);
								} else {
									if (nextStatus !== undefined) {
										submitForm(nextStatus);
									}
								}
								setIsUpdateVendorModalOpen(false);
							}}
						/>
					)}

					{isDeleteVendorModalOpen && (
						<ConfirmationModal
							content={
								<div
									style={{
										textAlign: 'left',
										backgroundColor: '#E6F5FF',
										padding: '10px',
										borderRadius: '5px',
										fontWeight: '500',
										color: 'black',
									}}
								>
									{vendorDetails.purchase_order.length > 0 ||
									vendorDetails.purchase_receive.length > 0
										? 'Deleting this Vendor will also permanently delete all related records linked to it (e.g., Purchase Bills, Purchase Received, Payments).'
										: 'Are you sure you want to delete'}
									{(vendorDetails.purchase_order.length > 0 ||
										vendorDetails.purchase_receive.length > 0) && (
										<div>This action cannot be undone.</div>
									)}
									{vendorDetails.purchase_order.length > 0 ||
									vendorDetails.purchase_receive.length > 0 ? (
										<div>Do you want to proceed</div>
									) : (
										<span
											style={{
												fontWeight: '600',
											}}
										>
											{vendorBasicData.vendor_name}
											<span>Vendor ?</span>
										</span>
									)}
								</div>
							}
							isOpen={isDeleteVendorModalOpen}
							title="Delete Vendor"
							onCancel={() => {
								setIsDeleteVendorModalOpen(false);
							}}
							onOk={handleDeleteVendor}
						/>
					)}

					{vendorStatusModal.isOpen && (
						<ConfirmationModal
							content={
								<p
									style={{
										textAlign: 'center',
										backgroundColor: '#E6F5FF',
										padding: '10px',
										borderRadius: '5px',
										fontWeight: '500',
										color: 'black',
									}}
								>
									Are you sure you want to mark{' '}
									<span
										style={{
											fontWeight: '600',
										}}
									>
										{vendorBasicData.vendor_name}{' '}
									</span>
									as {vendorStatusModal.status ? ' Active ' : ' Inactive '}?
								</p>
							}
							isOpen={vendorStatusModal.isOpen}
							title={`${vendorStatusModal.status ? 'Active' : 'Inactive '} Vendor`}
							onCancel={() => {
								setVendorStatusModal((prev) => ({
									...prev,
									isOpen: false,
								}));
							}}
							onOk={() => {
								if (vendorStatusModal.status) {
									markAsActive();
								} else {
									markAsInactive();
								}
								setVendorStatusModal((prev) => ({
									isOpen: false,
								}));
							}}
						/>
					)}
					{isVendorAutoSave && (
						<Modal
							className="deleteVendorsModal"
							title="Vendor Auto Save"
							isOpen={isVendorAutoSave}
							onClose={() => {
								setIsVendorAutoSave(false);
							}}
							cancelButton={() => {
								setIsVendorAutoSave(false);
							}}
						>
							<p
								style={{
									textAlign: 'center',
									backgroundColor: '#E6F5FF',
									padding: '20px 10px',
									marginBottom: '20px',
									borderRadius: '5px',
									fontWeight: '600',
									color: 'black',
								}}
							>
								You have unsaved changes. Do you want to continue without saving?
							</p>

							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 10,
									justifyContent: 'end',
								}}
							>
								<Button
									type="button"
									button="Leave Without Saving"
									className="mt-0 px-4 btn-danger relative"
									onClick={() => {
										setIsLocationBlocker(false);
										setIsVendorAutoSave(false);
										setTimeout(() => {
											navigate(isNextLocation.nextLocation?.pathname);
										}, 300);
									}}
								/>
								<Button
									type="button"
									className="mt-0 btn-primary add-pro"
									button="Save As Draft"
									disabled={
										!hasPermission('purchases.vendors.create', user?.role?.role_permissions)
									}
									onClick={() => {
										setIsLocationBlocker(false);
										setIsVendorAutoSave(false);
										submitForm(0);
									}}
								/>
								<Button
									type="button"
									button="Save and Continue"
									disabled={
										!hasPermission('purchases.vendors.create', user?.role?.role_permissions)
									}
									className="mt-0 px-4 btn-primary relative"
									onClick={() => {
										setIsVendorAutoSave(false);
										submitForm(1);
									}}
								/>
							</div>
						</Modal>
					)}
				</div>
			)}
		</>
	);
};

export default CreateVendors;
